import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(email, password, name);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 app-canvas" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img
            src="/branding/noras-welt-logo.png"
            alt="Noras Welt – Ihre Unterstützung im Alltag"
            className="w-64 max-w-full h-auto"
            data-testid="register-brand-logo"
          />
        </div>

        <div className="crm-card p-8">
          <h1 className="font-display font-bold text-2xl text-gray-900">Registrieren</h1>
          <p className="text-sm text-gray-500 mt-1">Lege dein Konto an, um Noras Welt zu nutzen.</p>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="name" className="text-xs font-semibold uppercase tracking-wider text-gray-600">Name</Label>
              <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1" data-testid="register-name-input" />
            </div>
            <div>
              <Label htmlFor="email" className="text-xs font-semibold uppercase tracking-wider text-gray-600">E-Mail</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" data-testid="register-email-input" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs font-semibold uppercase tracking-wider text-gray-600">Passwort</Label>
              <Input id="password" type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" data-testid="register-password-input" />
              <p className="text-xs text-gray-500 mt-1">Mindestens 6 Zeichen.</p>
            </div>
            <Button type="submit" disabled={submitting} className="w-full bg-black text-white hover:bg-gray-800" data-testid="register-submit-btn">
              {submitting ? "Speichern…" : "Konto anlegen"}
            </Button>
          </form>

          <div className="mt-6 text-sm text-gray-600 text-center">
            Bereits ein Konto?{" "}
            <Link to="/login" className="text-gray-900 font-medium underline-offset-2 hover:underline" data-testid="register-login-link">
              Anmelden
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
